import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

class AudioFileService {
    async getAudioFileById(id) {
        const headers = getAuthHeaders();
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v2/audiofiles/${id}`, { headers });
        return response.data;
    }

    async delete(id) {
        const headers = getAuthHeaders();
        const response = await axios.delete(`${process.env.REACT_APP_API_URL}/api/v2/audiofiles/${id}`, { headers });
        return response.data;
    }

    async rename(id, newName) {
        const headers = getAuthHeaders();
        const response = await axios.put(
            `${process.env.REACT_APP_API_URL}/api/v2/audiofiles/${id}/rename`,
            { name: newName },
            { headers },
        );
        return response.data;
    }
}

const audioFileServiceInstance = new AudioFileService();
export default audioFileServiceInstance;
